import React from "react";

import ProductImages from "./ProductImages";
import ProductInfo from "./ProductInfo";

import styles from "./productDetail.module.css";
import { Product } from "../../commonTypes";
import ProductRecommendation from "./ProductRecommendation";

interface Props {
  product: Product;
}

const ProductDetail = ({ product }: Props) => {
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.imagesContainer}>
          <ProductImages product={product} />
        </div>
        <div className={styles.infoContainer}>
          <ProductInfo key={product.id} product={product} />
        </div>
      </div>
      <div>
        <ProductRecommendation product={product} />
      </div>
    </div>
  );
};

export default ProductDetail;
